const dvCache = /* @__PURE__ */ new WeakMap();
function getDisplayValues(util, shape, colorMode) {
  const theme = util.editor.getCurrentTheme();
  const resolvedColorMode = colorMode ?? util.editor.getColorMode();
  const cached = dvCache.get(shape);
  if (cached && cached.theme === theme && cached.colorMode === resolvedColorMode) {
    return cached.values;
  }
  const values = {
    ...util.options.getDefaultDisplayValues(util.editor, shape, theme, resolvedColorMode),
    ...util.options.getCustomDisplayValues(util.editor, shape, theme, resolvedColorMode)
  };
  dvCache.set(shape, { theme, colorMode: resolvedColorMode, values });
  return values;
}
export {
  getDisplayValues
};
//# sourceMappingURL=getDisplayValues.mjs.map
